export const requirementsAidsdt = {
  requirementsAIDSDT: "Requirements AI-DS/DT",
  operationName: "Operation Name",
  proccessDuration: "Proccess Duration (seconds)",
  numOfSteps: "Number of Steps",
  stepName: "Step Name",
  stepDuration: "Step Duration",
  requiredCycleTime: "Required Cycle Time",
  lineRunTime: "Line Run Time",
  costOfOpeningNewStation: "Cost of Opening New Station",
  unmetTaktPen: "Unmet Takt Penalty",
  minMTTR: "Minimum MTTR",
  maxMTBF: "Maximum MTBF",
  budget: "Budget",
  partsToBeProduced: "Parts to be Produced",
  operationalEfficiency: "Operational Efficiency",
  costSavings: "Cost Savings",
  oee: "OEE",
  mtbf: "MTBF",
  mttr: "MTTR",
  amountOfMaterial: "Ποσότητα Υλικού",
  amountOfRawMaterial: "Ποσότητα Πρώτης Ύλης",
  amountOfRecycledMaterial: "Ποσότητα Ανακυκλωμένου Υλικού",
  amountOfCriticalMaterial: "Ποσότητα Κρίσιμου Υλικού",
  amountOfWasteAtEndOfLife: "Ποσότητα Αποβλήτων στο Τέλος του Κύκλου Ζωής",
  gasEmission: "Εκπομπές Αερίων",
  co2Emission: "Εκπομπές CO₂",
  amountProducedWastePerGeneration:
    "Ποσότητα Παραγόμενων Αποβλήτων ανά Παραγωγή",
  amountHazardousWastePerGeneration:
    "Ποσότητα Επικίνδυνων Αποβλήτων ανά Παραγωγή",
  transportationOfProductionEquipment: "Μεταφορά Εξοπλισμού Παραγωγής",
  earningPerProduct: "Κέρδος ανά Προϊόν",
  probabilityToAddAnOperationOrAModule:
    "Πιθανότητα Προσθήκης Λειτουργίας ή Ενότητας",
  probabilityToRemoveAnOperationOrAModule:
    "Πιθανότητα Αφαίρεσης Λειτουργίας ή Ενότητας",
  numberOfResourceGroup: "Αριθμός Ομάδας Πόρων",
  formalizedListOfAvailableWorkerSkillsInTheFactory:
    "Επίσημη Λίστα Διαθέσιμων Δεξιοτήτων Εργαζομένων στο Εργοστάσιο",
  minimumMTTR: "Ελάχιστο MTTR",
  maximumMTBF: "Μέγιστο MTBF",
};
